/**
 * The count in the sidebar is **not** a count of actions (research R-005).
 *
 * The reference's `CountUndoneTodosPhrase` says "3 deferred actions" when a container has nothing
 * available but something waiting, and "0 actions" only when there is genuinely nothing in it. The
 * difference matters: a context you have deliberately parked must not read the same as one you have
 * finished with, or you will keep re-opening it to check.
 *
 * Moved out of `features/home/model/sidebar.ts` (research R-008; T022): the phrase belongs beside the
 * home sidebar's own tally and beside 007's container-row phrase, so both say the same thing about
 * the same container from the same rule.
 */
export function countPhrase(available: number, deferred: number): string {
  const plural = (n: number) => (n === 1 ? 'action' : 'actions');
  return available === 0 && deferred > 0
    ? `${deferred} deferred ${plural(deferred)}`
    : `${available} ${plural(available)}`;
}
